export default {
  // 对话框类型：followees, followers, topic_followers, question_followers, article_followers
  type: '',
  data: [],
  pagination: null,
  loading: false
};